export default __webpack_public_path__ + "static/media/catlow_thumb.4cd6fa37.jpg";